import React from 'react';
import { XCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const ErrorMessage = ({ error, onRetry }) => {
    const navigate = useNavigate();
    const isCreditError = error.includes('Crédits insuffisants') || error.includes('Vous n\'avez pas assez de crédits pour créer cette commande')
    return (
        <div className="space-y-8 py-8">
            <div className="flex flex-col items-center justify-center space-y-4">
                <div className="relative">
                    <div className="w-32 h-32 bg-red-500/10 rounded-full flex items-center justify-center animate-[pulse_2s_ease-in-out_infinite]">
                        <div className="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center animate-[pulse_2s_ease-in-out_infinite] delay-75">
                            <div className="w-16 h-16 bg-red-500/60 rounded-full flex items-center justify-center scale-0 animate-[scale-in_0.5s_ease-out_forwards]">
                                <XCircleIcon className="h-full w-full text-white" />
                            </div>
                        </div>
                    </div>
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full animate-[ping_1s_cubic-bezier(0,0,0.2,1)_infinite]"></div>
                    <div className="absolute -bottom-1 -left-1 w-4 h-4 bg-red-500 rounded-full animate-[ping_1s_cubic-bezier(0,0,0.2,1)_infinite_0.2s]"></div>
                </div>
                <h3 className="text-2xl font-bold text-center bg-gradient-to-r from-red-500 to-red-700 bg-clip-text text-transparent animate-[fade-in_1s_ease-out]">
                    Erreur lors de la création de la commande
                </h3>
                <p className="text-center text-red-500 animate-[fade-in_1s_ease-out_0.3s]">
                    {error || "Une erreur est survenue lors de la création de la commande. Veuillez réessayer."}
                </p>
            </div>

            <div className="flex justify-center mt-8 gap-4">
                <button
                    type="button"
                    className="btn btn-outline btn-error btn-md"
                    onClick={onRetry}
                >
                    <ArrowPathIcon className="h-5 w-5 mr-2" />
                    Réessayer
                </button>
                {isCreditError && (
                    <button
                        type="button"
                        className="btn btn-outline btn-primary btn-md"
                        onClick={() => navigate('/produits')}
                    >
                        Recharger mes crédits
                    </button>
                )}
            </div>
        </div>
    );
};

export default ErrorMessage; 